export enum InviteType {
    NectaOne = 'NectaOne',
    VendorCatalog = 'VendorCatalog',
  }
  
  export interface Invite {
    id: number;
    text: string;
    tenantId: number;       // Wird nur befüllt bei Einladungen von NectaOne, bei VendorCatalog bleibt es null
    type: InviteType;
  }
  